import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { HeaderRoutes } from './header.routing';



import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { LoginModule } from '../login/login.module';
import { NzBadgeModule } from 'ng-zorro-antd/badge';

@NgModule({
  imports: [
    CommonModule,
    HeaderRoutes,

    NzGridModule,
    NzIconModule,
    NzDrawerModule,
    NzInputModule,
    FormsModule,
    NzSelectModule,
    NzModalModule,
    NzFormModule,
    ReactiveFormsModule,
    NzDropDownModule,
    NzTabsModule,
    NzUploadModule,
    NzButtonModule,
    NzAvatarModule,
    NzMenuModule,
    NzMessageModule,
    NzAutocompleteModule,
    LoginModule,
    NzBadgeModule
  ],
  declarations: [HeaderComponent]
})
export class HeaderModule { }
